import React from 'react';

interface SharePercentFooterProps {
  sharePercentInfo: {
    total?: number;
    totalPayable?: number;
    insurance?: number;
    countOfConsignment?: number;
    percentage?: number;
    usedCredit?:number
  };
  columnLength: number;
}

const SharePercentFooter: React.FC<SharePercentFooterProps> = ({ sharePercentInfo, columnLength }) => {
  const items = [
    { label: "اعتبار مصرف شده", value: sharePercentInfo?.usedCredit },
    { label: "مبلغ قابل پرداخت", value: sharePercentInfo?.totalPayable },
    // { label: "بیمه", value: sharePercentInfo?.insurance },
    // { label: "تعداد مرسوله‌ها", value: sharePercentInfo?.countOfConsignment },
    // { label: "درصد لحاظ شده", value: sharePercentInfo?.percentage },
  ];

  return (
    <>
      {items.map(({ label, value }, idx) => (
        <tr key={idx} className="w-full border-separate odd:bg-white even:bg-[#F1FFF8]">
          <td colSpan={columnLength} className="col-span-full p-2">
            <div className="flex justify-between">
              <p className="font-semibold">{label}</p>
              <div>
                <span className="text-[#209447] font-semibold text-base" dir="ltr">
                  {typeof value === "number" ? value.toLocaleString() : value || 0}
                </span>
                {idx < 3 && " ریال"}
              </div>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};

export default SharePercentFooter;